// extracted by mini-css-extract-plugin
module.exports = {"hero":"contact-module--hero--2nRU5","form":"contact-module--form--3zCAE"};